/**
 * Copyright © OXID eSales AG. All rights reserved.
 * See LICENSE file for license details.
 */

export function getLoader() {
    return $('.dd-ajax-loader.dd-content-loader');
}

export function getLang() {
    return $('#elm_lang').val();
}

export function toggleFormButtons(enable) {
    if(enable) {
        $('#myedit [type="submit"]button.btn-success').removeAttr('disabled');
        $('#myedit [type="submit"]button.btn-info').removeAttr('disabled');
        $('#myedit [type="submit"]button.btn-danger').removeAttr('disabled');
    } else {
        $('#myedit [type="submit"]button.btn-success').attr('disabled', true);
        $('#myedit [type="submit"]button.btn-info').attr('disabled', true);
        $('#myedit [type="submit"]button.btn-danger').attr('disabled', true);
    }
}

export function getWrapperHeight() {
    return $('.dd-veditor-wrapper', window.VisualEditorInstance.$container).height();
}

export function setWidgetActionsAccessibility(state = false) {
    let actions = $('.dd-veditor-widget-action, .dd-veditor-media-action, .dd-veditor-column-action');

    state ? actions.removeClass('disabled') : actions.addClass('disabled');
}

export function setEditorActionsAccessibility(state = false) {
    let actions = $('.dd-veditor-css-action, .dd-veditor-template-action, .dd-veditor-source-action, .dd-veditor-delete-all-action');

    state ? actions.removeClass('disabled') : actions.addClass('disabled');
    $('#elm_edit_hide_title, #elm_edit_islanding, #elm_edit_fullwidth, #elm_edit_cssclass').prop('disabled', !state);
}

export function setSEOUrl(html) {
    $('.dd-cms-url .form-control-static').html(html);
}

export function setSourceAction(attribute, html) {
    $('.dd-veditor-source-action').attr('data-original-title', attribute).html(html).tooltip('hide');
}

export function setSourceTextarea(sourceMode = false) {
    if (sourceMode) {
        $('textarea', window.VisualEditorInstance.$source).css('height', getWrapperHeight() + 'px');
    }
}

export function setTabContentHeight() {
    let $settings = $('#settings');
    let iHeight = $settings.outerHeight() - $('.tab-content', $settings).position().top - $('.dd-veditor-form-actions', $settings).outerHeight() - 1;

    $('.tab-content', $settings).height(iHeight);
}
